module.exports = __webpack_public_path__ + "static/media/undraw_on_the_way_roo.54e43e53.png";